import type { FaireProductEntity } from "../../entity_types/product";

export const p_yfjctwp2te: FaireProductEntity = {
  token: "p_yfjctwp2te",
  type: "product",
  name: "Tumbling Tower Butter Blanket",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/0f4ab75f4215a4290c15ca0a1640319a425fa987a0da55873bae337e23526f63.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5bb04e3bdcd8aec04ef345bef67ec1801650399fa26449bea69355e71f08a9b.jpeg"
  ],
  priceDollars: 44.5,
  description: "Butter Blankets\n\nEverything’s better with butter.\n\n\n\nLight and compact, but oh, so soft and silky. Our Butter Blanket is perfect for throwing around your house or tucking inside your travel bag. Created from post-consumer recycled products and engineered for optimal performance, your cuddle game has never been butter.\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * Available in 50\" x 60\" or 60\" x 80\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\nSleep Responsibly.\n\nWith its natural silky softness, our Butter Blankets are guaranteed to be your new favorite cuddle buddy. The best part? They’re also friendly to the environment. Our blankets are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And since it’s engineered to perform for years, you’re sure to hang on to it, helping to reduce yours.\n",
  tags: [],
  msrpDollars: 89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:37.269Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
